
export const apiPath = {
  // DDL Action
  GetDepartments: '/api/UserManager/GetDepartments',
  // GetMenuList: 'api/Auth/menuList',
  GetMenuList: '/api/AccountPackage/GetMenuList',
  GetEmployeesByAccountId: '/api/UserManager/GetEmployeesByAccountId',
  getImages: '/api/Tracker/getImages',
  CreateEmployee: '/api/UserManager/AddEmployee',
  EmployeeSelfRegistration: '/api/UserManager/EmployeeSelfRegistration',
  UpdateOrganizationProfile: '/api/Auth/UpdateOrganizationProfile',
  GetOrganizationProfile: '/api/Auth/GetOrganizationProfile',
  UpdateEmployee: '/api/UserManager/UpdateEmployee',
  SendDownloadLink: '/api/Auth/SendDownloadLink',
  SendOtpforVerifyEmail: '/api/Auth/SendOtpforVerifyEmail',
  VerifyOtp: 'api/Auth/VerifyOtp',
  SendLoginOtp: '/api/Auth/SendLoginOtp',
  VerifyLoginOtp: '/api/Auth/VerifyLoginOtp',
  DeleteEmployee: 'api/UserManager/DeleteEmployee',
  SignUp: '/api/Auth/signup',
  GetImagesByEmployeeId: '/api/TrackerWeb/GetImagesByEmployeeId',
  GetDesignations: '/api/UserManager/GetDesignations',
  GetSocialMedia: '/api/UserManager/GetSocialMedia',
  GetKeyStrokesEvents: '/api/TrackerWeb/GetKeyStrokesEvents',
  GetWebPageHistory: '/api/TrackerWeb/GetWebPageHistory',
  GetAppUseHistory: '/api/TrackerWeb/GetAppUseHistory',
  GetOnlineMeetings: 'api/UserManager/GetOnlineMeetings',
  GetEmployeeCosts: '/api/TimeTracking/GetEmployeeCosts',
  GetTaskCosts: '/api/TimeTracking/GetTaskCosts',
  Upload: '/api/Document/Upload',
  GetAllAppsAndWeb: '/api/TrackerWeb/GetAllAppsAndWeb',
  GetAllApsAndWebGroup: '/api/TrackerWeb/GetAllApsAndWebGroup',
  AddEmployeeAccessRestriction: 'api/UserManager/AddEmployeeAccessRestriction',
  GetAllDevices: '/api/TrackerWeb/GetAllDevices',
  GetEmployeeById: '/api/UserManager/GetEmployeeById',
  GetEmployeeAccessRestriction: '/api/UserManager/GetEmployeeAccessRestriction',
  DeleteEmployeeAccessRestriction:
    '/api/UserManager/DeleteEmployeeAccessRestriction',
  GetSearchKey: '/api/TrackerWeb/GetSearchKey',
  GetFileTransferHistory: '/api/TrackerWeb/GetFileTransferHistory',
  GetDashboardData: '/api/TrackerWeb/GetDashboardData',
  UninstallEmployeeAgent: 'api/TrackerWeb/UninstallEmployeeAgent',
  GetErrorLogs: '/api/TrackerWeb/GetErrorLogsByEmployeeId',
  GetTotalTimeWorkedByEmpId: '/api/TrackerWeb/GetTotalTimeWorkedByEmpId',
  GetBillHistoryByAccountId: '/api/Billing/GetBillHistoryByAccountId',
  DownloadInvoice: '/api/Billing/DownloadInvoice',
  UpdateEmailPreference: '/api/Billing/UpdateEmailPreference',
  GetAllPlaneWithCurrentPlane: '/api/Billing/GetAllPlaneWithCurrentPlane',
  SwitchPackage: '/api/Billing/SwitchPackage',
  GetPackageDetails: '/api/AccountPackage/GetPackageDetails',
  ChangePassword: '/api/Auth/ChangePassword',
  ResetPassword: '/api/Auth/ResetPassword',
  SendOtpForResetPassword: '/api/Auth/SendOtpForResetPassword',
  AddDepartment: '/api/UserManager/AddDepartment',
  AddDesignation: '/api/UserManager/AddDesignation',
  DeleteDepartment: '/api/UserManager/DeleteDepartment',
  DeleteDesignation: '/api/UserManager/DeleteDesignation',
  GetAllUserType: '/api/Auth/GetAllUserType',
  GetImageUrl: 'api/Document/GetImageUrl',
  GetImageBase64Async: '/api/Document/GetImageBase64Async',
  GetTimeEntries: '/api/TimeEntry/GetTimeEntries',
  GetDeviceAllName: '/api/TrackerWeb/GetDeviceAllName',
  GetMonthlyInOut: '/api/TimeEntry/GetMonthlyInOut',
  GetWorkloadInfo: '/api/TimeEntry/GetWorkloadInfo',
  // Dashboard api
  GetEmployeeWorkTime: '/api/EmployeeDashboard/employee-work-time',
  GetUsageStats: '/api/EmployeeDashboard/usage-stats',
  GetTopEmployees: '/api/EmployeeDashboard/top-employees',
  GetActivityLog: '/api/EmployeeDashboard/activity-log',
  AddScheduleReport: '/api/SchaduleReport/addScheduledReport',
  GetScheduleReport: '/api/SchaduleReport/getScheduledReport',
  UpdateScheduleReport: '/api/SchaduleReport/updateScheduledReport',
  DeleteScheduleReport: '/api/SchaduleReport/removeScheduledReport',
  AddRiskUserSetting: '/api/RiskUserSetting/Create',
  GetRiskUserSetting: '/api/RiskUserSetting/GetAll',
  DeleteRiskUserSetting: '/api/RiskUserSetting/Delete',
  UpdateRiskUserSetting: '/api/RiskUserSetting/Update',
  GetRiskEmployee: '/api/RiskTrigger/GetRiskEmployee',
  AddEmployeeFromExcel: '/api/UserManager/AddEmployeeFromExcel',
  GetActiveEmployees: '/api/UserManager/GetActiveEmployees',
  GetEmployeeFilters: '/api/UserManager/GetEmployeeFilters',
  GetScreenRecordHistoryByEmployeeId:
    '/api/TrackerWeb/GetScreenRecordHistoryByEmployeeId',
  // GetAllEmployeeActivityDurations:'/api/TrackerWeb/GetAllEmployeeActivityDurations',
  GetDailyEmployeeReport: '/api/TrackerWeb/GetDailyEmployeeReport',
  GetDailyEmployeeWorkload: '/api/TrackerWeb/GetDailyEmployeeWorkload',
  GetDailyRiskEmployee: '/api/TrackerWeb/GetDailyRiskEmployee',

  GetImageEvent: 'GetImageEvent',
  GetEmailHistoryEvent: 'GetEmailHistoryEvent',
  GetMeetingHistoryEvent: 'GetMeetingHistoryEvent',
  GetChatHistoryEvent: 'GetChatHistoryEvent',
  GetSocialMediaHistoryEvent: 'GetSocialMediaHistoryEvent',
  GetConsoleCommandEvent: 'GetConsoleCommandEvent',
  GetWebHistoryEvent: 'GetWebHistoryEvent',
  GetEmailHistory: 'GetEmailHistoryEvent',
  GetMettingHistory: 'GetMettingHistoryE',
  GetChatHistory: 'GetChatHistory',
  GetSocialMediaHistory: 'GetSocialMediaHistory',

  // All Monitoring with Image
  GetImagesWithBlob: 'GetImagesWithBlob',

  // Super visor
  GetSupervisors: 'api/UserManager/Get-Supervisors',
  PromoteEmployee: 'api/UserManager/promote-employee',
  UpdateEmployeeSupervisor: '/api/UserManager/UpdateEmployeeSupervisor',
  GetEmployeesBySuperVisorId: '/api/UserManager/get-employees-by-supervisor-id',
  TransferAllEmployees: '/api/UserManager/Transfer-All-Employees',
  DeleteSupervisor: '/api/UserManager/Delete-Supervisor',

  // Permission
  GetPermissions: '/api/permissions',
  CreatePermissions: '/api/permissions',
  UpdatePermissions: '/api/permissions',
  PermissionAssignments: '/api/permissions/assignments',
  GetEmployeePermissionConfiguration:
    '/api/permissions/employee/configuration-full',
  DeletePermission: '/api/permissions',

  // Promotional Content
  GetPromotionalContent: '/api/PromotionImage/get-all',
  CreatePromotionalContent: '/api/PromotionImage/upload',
  UpdatePromotionalContent: '/api/PromotionImage/update',
  DeletePromotionalContent: '/api/PromotionImage/delete',

  // Project Management
  ProjectType: '/api/Project/types',
  GetAllProjects: '/api/Project/all-projects',
  CreateProject: '/api/Project/create-project',
  UpdateProject: '/api/Project/update-project',
  DeleteProject: '/api/Project/delete-project',
  GetProjectDashboardSummary: '/api/Project/dashboard-summary',
  GetProjectHierarchy: '/api/Project/hierarchy',
  GetProjectDetailsText: '/api/Project/details-text',
  UpdateProjectDescription: '/api/Project/update-project-description',
  CreateMilestone: '/api/Project/create-milestone',
  CreateSprint: '/api/Project/create-sprint',
  UpdateSprint: '/api/Project/update-sprint',
  DeleteSprint: '/api/Project/delete-sprint',
  CreateTask: '/api/Project/create-task',
  UpdateTask: '/api/Project/update-task-details',
  DeleteTask: '/api/Project/delete-task',
  ReviewTask: '/api/Project/review-task',
  GetMilestoneById: '/api/Project/milestones',
  RecentTasks: '/api/Project/recent-tasks',
  ProjectDropdown: '/api/Project/dropdown/projects',
  SprintDropdown: '/api/Project/dropdown/sprints',
  // New Task
  ProjectSummary: "/api/Project/dashboard-summary",
  AllProjectList: "/api/Project/list",
  TeamWorkload: "/api/Project/team-workload",
  CreateProjectV2: "/api/Project/create",
  UpdateProjectV2: "/api/Project/update",
  CheckProjectSlug: "/api/Project/slug/check",
  // Organisation collaboration
  CollaborationStatus: "/api/Collaboration/status",
  CollaborationRequest: "/api/Collaboration/request",
  CollaborationRequests: "/api/Collaboration/requests",
  CollaborationAccept: (collaborationId: number | string) => `/api/Collaboration/requests/${collaborationId}/accept`,
  CollaborationReject: (collaborationId: number | string) => `/api/Collaboration/requests/${collaborationId}/reject`,
  CollaborationRevoke: "/api/Collaboration/revoke",
  AllTasks: "/api/Project/tasks",
  TaskDetails: (taskId: string) => `/api/Project/tasks/${taskId}/full`,
  CreateTaskV2: '/api/Project/tasks/create',
  DeleteProjectV2: "/api/Project/delete",
  MileStone: "/api/Project/milestones",
  ProjectFiles: "/api/Project/files",
  UpdateTaskV2: '/api/Project/tasks/update',
  UpdateTaskAssignees: (taskId: string) => `/api/Project/tasks/${taskId}/assignees`,
  GetTaskAndMilestones: "/api/Project/tasks-and-milestones",
  Members: "/api/Project/members",
  DeleteMilestone: "/api/Project/milestones",
  UploadProjectFile: "/api/Project/files/upload",
  DeleteProjectFile: "/api/Project/files",
  AddAttachment: `/api/Project/tasks`,
  DeleteAttachment: "/api/Project/tasks/attachments",
  CreateTaskNotes: "/api/Project/tasks/notes/create",
  GetTaskNotes: "/api/Project/tasks/notes",
  UpdateTaskNotes: "/api/Project/tasks/notes/update",
  DeleteTaskNotes: "/api/Project/tasks/notes",
  DeleteTaskAttachment: "/api/Project/tasks/attachments",
  ImportTasks: "/api/Project/tasks/bulk-import",
  DeletedTasks: "/api/Project/tasks/deleted",
  RestoreTask: "/api/Project/tasks",
  DownloadTaskAttachment: "/api/Project/tasks/attachments",
  DownloadProjectFile: "/api/Project/files",
  CreateMilestoneV2: "/api/Project/milestones/create",
  UpdateMilestoneV2: "/api/Project/milestones/update",
  ExportTasks: "/api/Project/tasks/export",
  TaskShift: "/api/Project/tasks/reschedule/shift",
  TaskReOrder: "/api/Project/tasks/reschedule/reorder",

  // Inchstones (sub-grouping under Milestone)
  GetInchstones: "/api/project/inchstones",
  CreateInchstone: "/api/project/inchstones/create",
  UpdateInchstone: "/api/project/inchstones/update",
  DeleteInchstone: "/api/project/inchstones",

  TransferTask: '/api/Project/transfer-tasks-bulk',
  DriveLog: "/api/DriveActivity",
  ArchiveProject: "/api/Project/bulk-archive",
  CreateRemarks: "/api/Project/tasks/remarks/create",
  DeleteRemarks: "/api/Project/tasks/remarks",
  UpdateRemarks: "/api/Project/tasks/remarks/update",
  GetTaskRemarks: (taskId: string) => `/api/Project/tasks/${taskId}/remarks`,
  GetTaskAttachments: (taskId: string) => `/api/Project/tasks/${taskId}/attachments`,
  GetTaskChat: (taskId: string) => `/api/Project/tasks/${taskId}/chat`,
  SendTaskChat: (taskId: string) => `/api/Project/tasks/${taskId}/chat/send`,
  SearchTaskChat: (taskId: string) => `/api/Project/tasks/${taskId}/chat/search`,
  MarkTaskChatRead: (taskId: string) => `/api/Project/tasks/${taskId}/chat/read`,
  GetMilestonesDropdown: "/api/Project/dropdown/milestones",
  GetTasksDropdown: "/api/Project/dropdown/tasks",
  ApproveTask: `/api/Project/tasks`,
  RejectTask: `/api/Project/tasks`,
  ApproveBulkTasks: `/api/Project/tasks/approve-bulk`,
  RejectBulkTasks: `/api/Project/tasks/reject-bulk`,
  GetProjectSupervisors: "/api/Project/supervisors",
  AssignProjectSupervisor: "/api/Project/supervisors/assign",
  DeleteProjectSupervisor: "/api/Project/supervisors/remove",
  GetGoogleTaskSyncStatus: "/api/GoogleTaskSync/GetStatus",
  ToggleGoogleTaskSync: "/api/GoogleTaskSync/Toggle",
  GetTaskNotificationConfig: "/api/TaskNotification/GetConfig",
  UpdateTaskNotificationConfig: "/api/TaskNotification/UpdateConfig",
  DeleteTaskById: "/api/Project/tasks",
  PermanentDeleteTask: "/api/Project/tasks/bulk-delete",
  ToggleTaskHoldStatus: (taskId: string) => `/api/Project/tasks/${taskId}/toggle-hold`,
  RessetToTodo: (taskId: string) => `/api/Project/tasks/${taskId}/reset-to-todo`,
  // New Onboarding API
  GetPublicPricePlans: "/api/PublicPricing/plans",
  CheckTrialStatus: "/api/PublicPricing/check-trial",
  GetAccountStatus: "/api/Subscription/account-status", // This is for checking the account status like if the user has an active subscription, trial, or is in a grace period.
  // Subscriptions Management
  GetCurrentSubscription: "/api/Subscription/current", // This is for fetching details about the user's current subscription, including plan details, billing cycle, and next billing date.
  GetSubscriptionSlotsAvailability: "/api/Subscription/slot-availability",
  GetTrialPeriodEmployeeList: "/api/Subscription/trial-employees",
  PreviewSelectPlan: "/api/Subscription/preview-select-plan",
  SelectPlan: "/api/Subscription/select-plan",
  PreviewUpgrade: "/api/Subscription/preview-upgrade",
  UpgradePlan: "/api/Subscription/upgrade",
  ScheduleDowngrade: "/api/Subscription/schedule-downgrade",
  PreviewAddSlots: "/api/Subscription/preview-add-slots",
  AddSlots: "/api/Subscription/add-slots",
  CancelPendingBill:"/api/Subscription/cancel-pending-bill",

  // Account admin: list / impersonate / CRUD / lifecycle actions.
  // Endpoints that take an account id use the `paramId` field of useAxiosRequest
  // to append `${id}` or `${id}/<action>` to the base URL.
  GetAllAccounts: "/api/AccountAdmin/accounts",
  ImpersonateAccount: "/api/AccountAdmin/accounts",
  CreateAccountByAdmin: "/api/AccountAdmin/accounts",
  GetAccountById: "/api/AccountAdmin/accounts",
  DeleteAccountById: "/api/AccountAdmin/accounts",
  SetAccountFree: "/api/AccountAdmin/accounts",
  ActivateCustomPlan: "/api/AccountAdmin/accounts",
  GenerateBillingReport: "/api/AccountAdmin/accounts",
  ReactivateAccount: "/api/AccountAdmin/accounts",
  SuspendAccount: "/api/AccountAdmin/accounts",
  // Admin config and plans management
  AdminConfig: "/api/AccountAdmin/config",
  UpdateAdminConfig: "/api/AccountAdmin/config",
  GetPlansForAdmin: "/api/AccountAdmin/plans",
  CreatePlansByAdmin: "/api/AccountAdmin/plans",
  UpdatePlans: "/api/AccountAdmin/plans",
  DeletePlans: "/api/AccountAdmin/plans",
  CreatePricingPlan: (planId: number | string) => `/api/AccountAdmin/plans/${planId}/pricing`,
  CreatePlanFeatures: (planId: number | string) => `/api/AccountAdmin/plans/${planId}/features`,

  // Tour guide
  TourGuideStatus: "/api/TourGuide/status",
  UpdateTourGuideStatus: "/api/TourGuide/status",
  TourGuideOrganizations: "/api/TourGuide/admin/organizations",
  UpdateTourGuideOrgStatus: (accountId: number | string) => `/api/TourGuide/admin/organizations/${accountId}/status`,
  TourGuideKeys: "/api/TourGuide/admin/keys",
  TourGuideKey: (keyId: number | string) => `/api/TourGuide/admin/keys/${keyId}`,
  TourGuideContents: "/api/TourGuide/admin/contents",
  TourGuideContent: (contentId: number | string) => `/api/TourGuide/admin/contents/${contentId}`,

  GetLatestTkToUsdRate: "/api/CurrencyRate/GetLatestTkToUsdRate",
  CreatePaymentIntent: "/api/Billing/Stripe/CreateCheckoutSession",


  // Dashboard
  GetProjectOverview: "/api/Project/overview/projects",
  GetTaskCounts: "/api/Project/overview/task-counts",
  DashboardProjectOverview: "/api/Project/overview/summary",

  // Resource Management
  GetAllResourcesWithCurrentTask: "/api/Project/employees/current-task",


  // SQA
  GetProjectsSQAList: (projectId: number | string) => `/api/Project/sqa/${projectId}`,
  AssignSQA: '/api/Project/sqa/assign',
  RemoveSQA: '/api/Project/sqa/remove',

  CreateTaskForSQA: "/api/Project/sqa/tasks/create",
  AddTaskOnSQATask: "/api/Project/sqa/tasks/add-tasks",
  RemoveTaskFromSQATask: "/api/Project/sqa/tasks/remove-tasks",
  AssignSqaBugs: "/api/Project/sqa/bugs/assign",

  // Omni Route AI
  CreateOmniRouteAI: "/api/OmniRouteAI/Create",
  GetOmniRouteAI: "/api/OmniRouteAi/GetAll",
  UpdateOmniRouteAI: "/api/OmniRouteAi/Update",
  DeleteOmniRouteAI: (omniRouteAIId: number | string) => `/api/OmniRouteAI/Delete/${omniRouteAIId}`,

  // Deskbird integration (spec 036)
  DeskbirdIntegration: '/api/IntegrationSettings/deskbird', // GET status, DELETE revoke
  DeskbirdIntegrationGenerate: '/api/IntegrationSettings/deskbird/generate', // POST, no body
};
export type TApiPath = keyof typeof apiPath;
